import * as yup from 'yup';

const invoiceValidationSchema = yup.object().shape({
  invoice_number: yup
  .string()
  .trim()
  .required('Invoice number is required'),
  
  contract_id: yup
    .string()
    .required('Contract ID is required'),
  
  client: yup.object().shape({
    id: yup
      .string()
      .required('Client ID is required'),
    name: yup
      .string()
      .required('Client name is required'),
    billing_address: yup
      .string()
      .required('Billing address is required')
      .min(5, 'Billing address must be at least 5 characters')
  }),

  billing_date: yup
    .date()
    .required('Billing date is required')
    .typeError('Billing date must be a valid date'),

  due_date: yup
    .date()
    .required('Due date is required')
    .typeError('Due date must be a valid date')
    .min(
      yup.ref('billing_date'),
      'Due date must be after or equal to billing date'
    ),

  line_items: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.string().required('Line item ID is required'),

        sale_date: yup
          .string()
          .nullable(),

        description: yup
          .string()
          .required('Description is required')
          .test(
            'not-empty-rich-text',
            'Description is required',
            (value) => {
              if (!value) return false;
              const plainText = value
                .replace(/<[^>]*>/g, '')
                .replace(/&nbsp;/g, ' ')
                .trim();

              return plainText.length > 0;
            }
          ),

        amount_minor: yup
          .number()
          .typeError('Amount is required')
          .required('Amount is required')
          .min(0, 'Amount cannot be negative'),
      })
    )
    .min(1, 'At least one line item is required')
    .required('Line items are required'),

  tax_rate_bps: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value
    )
    .typeError("Tax rate is required")
    .required("Tax rate is required")
    .moreThan(0, "Tax rate must be greater than 0")
    .max(10000, "Tax rate cannot exceed 100%"),

  status: yup
  .string()
  .required("Status is required")
  .oneOf(["OPEN", "OVERDUE", "PAID"], "Invalid invoice status"),
});

export default invoiceValidationSchema;
